import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { LogoutIcon } from '../icons/icons';
import { userLogout, loginReset } from '../../redux/actions/AccessAction';
import GlobalSnackbar from '../global_snackbar/GlobalSnackbar';
import { decrypt } from '../../util/Security';
import { Typography } from '@mui/material';

const LogoutMenu = () => {
    const [logout, setLogout] = useState(() => false);
    const [snackbarState, setSnackbarState] = useState({
        open: false,
        message: '',
        severity: 'info',
    });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { logoutDetails } = useSelector((state) => state.accessState);

    useEffect(() => {
        if (logoutDetails) {
            if (logoutDetails?.status === 200) {
                dispatch(loginReset());
                localStorage.removeItem('login');

                setTimeout(() => {
                    navigate('/thank-you');
                }, 1);
            } else {
                setSnackbarState({
                    open: true,
                    message: logoutDetails?.message,
                    severity: 'error',
                });
            }
        }
    }, [logoutDetails]);

    const handleSnackbarClose = () => {
        setSnackbarState(() => {
            return { open: false, message: '', severity: 'info' };
        });
    };

    const handleLogout = () => {
        let data = decrypt(localStorage.getItem('login'));
        dispatch(userLogout(data?.candidateId));
    };

    return (
        <>
            <Button
                variant='text'
                onClick={handleLogout}
                sx={{ fontWeight: 600, fontSize: '1rem',mt:'.8rem' }}
                disableElevation
                disableRipple
                disableFocusRipple
                disableTouchRipple>
                <LogoutIcon fontSize='inherit' sx={{ fontWeight: 600, fontSize: '1rem' ,pr:1 }} />
                <Typography variant='body2'>{` Logout`}</Typography>
            </Button>

            {/* snack bar section */}
            <GlobalSnackbar
                open={snackbarState.open}
                onClose={handleSnackbarClose}
                message={snackbarState.message}
                theme={snackbarState.severity}
            />
        </>
    );
};

export default LogoutMenu;
